import styled from 'styled-components';
import { Dialog } from 'cdk-radial';
import { useTheme } from '../../../../contexts/Theme';
import { BUTTON_VARIANTS } from 'cdk-radial';
import {
  SimpleTable,
  SimpleTableBody,
  SimpleTableHead,
  SimpleTableHeader,
  SimpleTableRow,
  SimpleTableData,
} from 'cdk-radial';
import { useTranslation } from 'react-i18next';

export const StyledDialog = styled(Dialog)`
  min-width: 715px;
  max-width: 30%;
  margin-top: 60px;
  z-index: 9999;
`;

export const StyledDialogTitle = styled.div`
  fontweight: 600;
  font-size: 1.25rem;
  line-height: 24px;
  text-transform: capitalize;
`;

export const StyledDialogTitleContainer = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
`;

const StyledSimpleTable = styled(SimpleTable)`
  width: 580px;
  margin-top: 20px;
`;
const StyledTableColumn = styled(SimpleTableData)`
  width: 180px;
`;

export const StyledDialogContentText = styled.div``;

interface IDeleteConfirmDialog {
  isOpen: boolean;
  onYes: () => void;
  onNo: () => void;
  title: string;
  subject: string;
  modalTitle?: string;
}
export const DeleteConfirmDialog = ({
  isOpen,
  onYes,
  onNo,
  title,
  subject,
  modalTitle = "alert"
}: IDeleteConfirmDialog): JSX.Element => {
  const { t } = useTranslation();
  const { darkMode } = useTheme();
  return (
    <div>
      <StyledDialog
        buttonsProps={[
          {
            id: 'Cancel',
            dataTestId: 'delete-dialog-cancel',
            onClick: onNo,
            text: t('deleteDialog.cancel'),
            variant: BUTTON_VARIANTS.TEXT,
            style: {
              color: darkMode ? 'white' : 'black',
            },
          },
          {
            id: 'delete-dialog-yes',
            onClick: onYes,
            text: t('deleteDialog.delete'),
            variant: BUTTON_VARIANTS.PRIMARY,
            style: {
              color: darkMode ? 'black' : 'white',
              backgroundColor: darkMode ? 'white' : 'black',
            },
          },
        ]}
        id="delete-dialog-no"
        isOpen={isOpen}
        onClose={onNo}
        title={
          <StyledDialogTitleContainer>
            <StyledDialogTitle>{t('deleteDialog.confirmDelete')}</StyledDialogTitle>
          </StyledDialogTitleContainer>
        }
      >
        <StyledDialogContentText>
          {`${t('deleteDialog.willBeDeleted')}`}
        </StyledDialogContentText>
        <StyledSimpleTable>
          <SimpleTableHead>
            <SimpleTableRow>
              <SimpleTableHeader>{t('deleteDialog.title')}</SimpleTableHeader>
              <SimpleTableHeader>{t('deleteDialog.subject')}</SimpleTableHeader>
            </SimpleTableRow>
          </SimpleTableHead>
          <SimpleTableBody>
            <SimpleTableRow>
              <StyledTableColumn>{title}</StyledTableColumn>
              <SimpleTableData>{subject}</SimpleTableData>
            </SimpleTableRow>
          </SimpleTableBody>
        </StyledSimpleTable>
      </StyledDialog>
    </div>
  );
};
